module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_iter-step.js
// module id = 83
// module chunks = 0 1 2 3 4